export default function TriangleSvg() {
  return (
    <svg width="20" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m10 0 10 12H0L10 0z" fill="#E0E7F2"/>
    </svg>
  );
}
